module.exports = __webpack_public_path__ + "img/icon_delete.3964ad4b.svg";